/**
 * PostHog Analytics Events for Task Instructions
 *
 * Tracks: card views, action chip clicks (call/text/email),
 * collapse/expand, reasoning expansion, and feedback (thumbs-down).
 */

// ============================================
// Event Names
// ============================================

export const TASK_INSTRUCTIONS_EVENTS = {
  // Card lifecycle
  CARD_VIEWED: 'task_instructions_card_viewed',
  CARD_COLLAPSED: 'task_instructions_card_collapsed',
  CARD_EXPANDED: 'task_instructions_card_expanded',

  // Action chip clicks
  ACTION_CLICKED: 'task_instructions_action_clicked',

  // Reasoning
  REASONING_EXPANDED: 'task_instructions_reasoning_expanded',
  REASONING_COLLAPSED: 'task_instructions_reasoning_collapsed',

  // Feedback
  FEEDBACK_SUBMITTED: 'task_instructions_feedback_submitted',
  FEEDBACK_SKIPPED: 'task_instructions_feedback_skipped',
} as const;

// ============================================
// Property Keys
// ============================================

export const TASK_INSTRUCTIONS_PROPERTIES = {
  // Context
  MATTER_ID: 'matter_id',
  TASK_ID: 'task_id',
  INSTRUCTION_ID: 'instruction_id',

  // Instruction metadata
  GENERATION_MODE: 'generation_mode',
  CONFIDENCE: 'confidence',
  ACTION_COUNT: 'action_count',

  // Action chip
  ACTION_TYPE: 'action_type', // 'call' | 'text' | 'email' | 'internal' | 'manual'
  ACTION_INDEX: 'action_index', // 0-based position in next_actions list

  // Feedback
  HAS_REASON: 'has_reason',
} as const;

// ============================================
// Type Helpers
// ============================================

export type TaskInstructionsEvent =
  (typeof TASK_INSTRUCTIONS_EVENTS)[keyof typeof TASK_INSTRUCTIONS_EVENTS];

export type TaskInstructionsProperty =
  (typeof TASK_INSTRUCTIONS_PROPERTIES)[keyof typeof TASK_INSTRUCTIONS_PROPERTIES];
